import React, { useEffect } from 'react'
import PhoneInput from 'antd-phone-input'

import { Constants } from '@/utils'

// Everywhere outside this file, a phone number is { code, phone, short }.
// antd-phone-input uses     { countryCode, areaCode, phoneNumber, isoCode }.
// This file is the only place where those two shapes meet.

const toLib = (legacy) => {
    if (!legacy) return undefined
    return {
        countryCode: legacy.code,
        phoneNumber: legacy.phone,
        isoCode: legacy.short ? String(legacy.short).toLowerCase() : undefined,
    }
}

const toLegacy = (lib) => {
    if (!lib) return undefined
    return {
        code: lib.countryCode,
        phone: `${lib.areaCode ?? ''}${lib.phoneNumber ?? ''}`.replace(/\D/g, ''),
        short: lib.isoCode ? String(lib.isoCode).toUpperCase() : undefined,
    }
}

const PhoneNumberInput = ({ value = Constants.DEFAULT_PHONE, onChange, ...rest }) => {
    // PhoneInput emits its own shape; the form must only see legacy shape.
    const handleChange = (next) => onChange?.(toLegacy(next))

    // Safety net: if the form-held value ever ends up in lib shape (PhoneInput leaking
    // before handleChange takes over), re-emit it as legacy. Self-stabilizes.
    useEffect(() => {
        if (value && 'countryCode' in value) onChange?.(toLegacy(value))
    }, [value, onChange])

    return <PhoneInput {...rest} value={toLib(value)} onChange={handleChange} enableSearch disableParentheses />
}

export default PhoneNumberInput

